import { parsePhoneNumberFromString } from 'libphonenumber-js';

export function toReadablePhoneNumber(input: string | null | undefined) {
  if (!input) {
    return input;
  }

  const phoneNumber = parsePhoneNumberFromString(input, {
    defaultCountry: 'SE',
  });

  if (!phoneNumber) {
    return input;
  }

  return phoneNumber.formatNational();
}
